import React from 'react';

import { showPrices } from '../constants/settings';

export default function SuggestedProductContent({
  product,
  getCoverImageForProduct,
  formatPrice,
}) {
  const coverImage = getCoverImageForProduct(product);
  const shouldShowPrice =
    showPrices &&
    typeof product.amount === 'number' &&
    product.amount > 0 &&
    product.currency;

  return (
    <div className="suggested-product-content">
      {coverImage?.imageURL && (
        <img
          src={coverImage.imageURL}
          alt={product.productName}
          className="suggested-product-image"
        />
      )}
      <div className="suggested-product-info">
        <span className="suggested-product-name">{product.productName}</span>
        {shouldShowPrice ? (
          <span className="suggested-product-price">
            {formatPrice(product.amount, product.currency)}
          </span>
        ) : null}
      </div>
    </div>
  );
}
